
import React from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Users } from "lucide-react";

interface MentorshipInfoSectionProps {
  title?: string;
  description?: string;
  coverImageUrl?: string | null;
  isGroup?: boolean;
  maxParticipants?: number;
  gameName?: string;
  price?: number;
}

export const MentorshipInfoSection: React.FC<MentorshipInfoSectionProps> = ({
  title,
  description,
  coverImageUrl,
  isGroup,
  maxParticipants,
  gameName,
  price,
}) => {
  // Format price correctly - price is already in cents from database
  const formattedPrice = price !== undefined && price !== null ? 
    (price === 0 ? 'Gratuito' : new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(price / 100)) : 
    'R$ 100,00';
  
  return (
    <div className="space-y-4">
      {coverImageUrl && (
        <AspectRatio ratio={16 / 9} className="overflow-hidden rounded-lg">
          <img
            src={coverImageUrl}
            alt={title || "Mentoria"}
            className="w-full h-full object-cover"
          />
        </AspectRatio>
      )}

      <div className="space-y-2">
        <h3 className="text-xl font-bold">
          {title || "Mentoria de " + gameName}
        </h3>
        
        {description && (
          <p className="text-gray-400 text-sm">{description}</p>
        )}
        
        <div className="flex flex-col gap-2 mt-4">
          {gameName && (
            <p className="text-sm text-[#00B6F0]">Jogo: {gameName}</p>
          )}
          
          {isGroup && (
            <div className="flex items-center gap-2">
              <Users className="h-4 w-4 text-[#00B6F0]" />
              <p className="text-sm text-gray-300">
                Mentoria em grupo (máximo {maxParticipants || 'não especificado'} participantes)
              </p>
            </div>
          )}
          
          <div className="flex justify-between items-center mt-2 pt-3 border-t border-[#223342]">
            <span className="text-sm text-gray-300">Valor:</span>
            <span className="text-lg font-bold text-[#00B6F0]">{formattedPrice}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
